<template>
    <div>
        <div
            class="image-edit-area"
            id="image-edit-area"
            :style="{'width': scaledWidth + 'px'}"
            v-show="imageLoaded"
        >

            <img
                :src="imgUrl"
                class="img-fluid image-placeholder disselect"
                ref="screenImage"
                @load="listenforload"
                :style="{'width': scaledWidth+ 'px', 'height': scaledHeight +'px'}"
                v-if="selectedPage"
            />

            <vue-draggable-resizable
                v-for="(signatureBlock) in signatures.filter(signature => signature.applicant)"
                :key="signatureBlock.id"
                :x="signatureBlock.x"
                :y="signatureBlock.y"
                :w="240"
                :h="signatureBlock.height"
                :ref="'draggable' + signatureBlock.id"
                :draggable="false"
                :resizable="false"
                :parent="true"
            >
                <div class="mask" @click="openPad(signatureBlock)">
                    <div v-if="!isShowSignature(signatureBlock)"
                         class="max-h maskActive col-12 d-flex justify-content-between align-items-center p-2">
                        <!-- need to hide the icon and label -->
                        <i class="fas fa-pen-nib fa-2x text-white mr-3" :id="`fa-${signatureBlock.id}`"></i>
                        <p class="mask-label mb-0">
                            <strong>Click to Sign</strong>
                        </p>
                    </div>
                    <img
                        v-if="isShowSignature(signatureBlock)"
                        :src="customerSignature.temporary_url"
                        style="width: 100%; height: auto;"
                    />

                    <!-- <small
                      v-if="isShowSignature(signatureBlock)"
                      style="font-size:12px; position: absolute; bottom: -20px; width: 100%; left: 0;"
                    >{{customerSignature.name}} - {{ $moment(customerSignature.date.date ? customerSignature.date.date + 'Z' : customerSignature.date + 'Z').format('DD/MM/YYYY') }}</small> -->
                </div>
            </vue-draggable-resizable>
        </div>
        <signature-modal
            :signature="signature"
            :submit-url="submitUrl"
            :timeline-url="timelineUrl"
            :save-signature-url="saveSignatureUrl"
            :applicant="applicant"
            :open.sync="open"
            :verification-signature="verificationSignature"
            :contract-signature="contractSignature"
        ></signature-modal>
    </div>
</template>
<script>
import SignatureModal from "./SignatureModal";
import {mapGetters} from "vuex";

export default {
    components: {
        SignatureModal
    },
    props: {
        selectedPage: {
            required: true,
            type: Object
        },
        imgUrl: {
            required: true,
            type: String
        },
        saveSignatureUrl: {
            required: true,
            type: String
        },
        signatures: {
            required: true,
            type: Array
        },
        timelineUrl: {
            required: true,
            type: String
        },
        submitUrl: {
            required: true,
            type: String
        },
        contractSignature: {
            required: true,
            type: Object
        },
        unsignedBlocks: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            scaledHeight: 880,
            scaledWidth: 680,
            imageLoaded: false,
            applicant: null,
            signature: null,
            open: false,
            verificationSignature: false
        };
    },
    methods: {
        openPad(signature) {
            this.signature = signature;
            this.applicant = signature.applicant;
            this.open = true;
        },
        listenforload() {
            this.scaledHeight = this.$refs.screenImage.naturalHeight / 1.25;
            this.scaledWidth = this.$refs.screenImage.naturalWidth / 1.25;
            this.imageLoaded = true;
        },
        isShowSignature(signature) {
            if (signature.is_traversed) return this.customerSignature ? true : false;
            return false;
        },
        traversedSignature(signature) {
            axios
                .put(
                    `/applications/${this.contractSignature.application_id}/${signature.applicant_id}/document-contract/${this.contractSignature.id}/signatures/${signature.id}`,
                    {}
                )
                .then(res => {
                    this.signature.is_traversed = true;
                    let faElem = document.getElementById(`fa-${signature.id}`);
                    if (faElem) faElem.remove(); // force remove all fa
                    this.$emit("traversing-document", true);
                })
                .catch(err => {
                    console.error(err);
                });
        }
    },
    mounted() {
        this.$bus.$on("add-signature", value => {
            if (this.signature) this.traversedSignature(this.signature);
        });

        this.$bus.$on("change-page", value => {
            // make image loaded false;
            //   every time page number changes;
            this.imageLoaded = false;
        });

        this.$bus.$on("insert-verification-signature", value => {
            this.verificationSignature = true;
            this.open = true;
        });
    },
    beforeDestroy() {
        this.$bus.$off("add-signature");
        this.$bus.$off("change-page");
        this.$bus.$off("insert-verification-signature");
    },
    watch: {
        open(newVal, oldVal) {
            // set the verification signature false every time it is closed;
            if (!newVal) this.verificationSignature = false;
        }
    },
    computed: {
        ...mapGetters({
            customerSignature: "signature/getCustomerSignature"
        })
    }
};
</script>

<style lang="sass" scoped>
.image-edit-area
    background:
        size: contain
        repeat: no-repeat
        position: center
    justify:
        content: center
    display: flex
    resize: both
    position: relative
    margin: auto
    //   width: 100%;
    height: 100%

%mask
    display: block
    position: absolute
    top: 0%
    left: 0%
    width: 100%
    cursor: pointer
    height: 100%
    z:
        index: 1

.mask
    @extend %mask
    height: 64px
    width: 240px

.maskActive
    border:
        radius: 5px
    background:
        color: #f8a52b

.maskImage
//   border: dashed
  background:
    color: transparent

.mask-label
    font:
        size: 18px !important
    color: #fff


.image-placeholder
    border:
        width: 0.5px
        style: solid
        color: #bdbdbd


.mask-button
    background: transparent
    border: none
    float: right

.max-h
    height: 64px
    width: 240px


.disselect
    -webkit:
        user:
            drag: none
            select: none
    -khtml:
        user:
            drag: none
            select: none
    -moz:
        user:
            drag: none
            select: none
    -o:
        user:
            drag: none
            select: none
    user:
        drag: none
        select: none
</style>
